// extracted by mini-css-extract-plugin
export default {"contentStyle":"AreYouSureModal_contentStyle__MVGlD","container":"AreYouSureModal_container__6fhxg","footer":"AreYouSureModal_footer__YD582"};